import { ApiService } from '../Services/APIService';
import { ENDPOINTS } from '../Utils/APIConstants';
import { StorageUtils } from "../Utils/StorageUtils";  

export const AnalyticService = {

  fetchLinkAnalytics: async (linkId) => {
    // Retrieve the token from StorageUtils
    const token = StorageUtils.getUserData()?.token;
    // Set the token in ApiService
    ApiService.setAuthToken(token);
    // Make the API call for link analytics
    return ApiService.get(`${ENDPOINTS.LINK_ANALYTICS}/${linkId}/analytics`);
  },

  fetchSummaryAnalytics: async (summaryId) => {
    // Retrieve the token from StorageUtils
    const token = StorageUtils.getUserData()?.token;
    // Set the token in ApiService
    ApiService.setAuthToken(token);
    // Make the API call for summary analytics - corrected endpoint
    return ApiService.get(`${ENDPOINTS.ANALYTICS}/summaries/${summaryId}/analytics`);
  },

  // Method to get page visit count for a summary by filtering Click records
  fetchSummaryPageVisits: async (summaryId) => {
    // Retrieve the token from StorageUtils
    const token = StorageUtils.getUserData()?.token;
    // Set the token in ApiService
    ApiService.setAuthToken(token);
    // Make the API call to get summary clicks - corrected endpoint
    return ApiService.get(`${ENDPOINTS.ANALYTICS}/summaries/${summaryId}/clicks`);
  },

  // NEW: Fetch impressions timeline for links
  fetchLinkImpressionsTimeline: async (linkId, days = 7) => {
    // Retrieve the token from StorageUtils
    const token = StorageUtils.getUserData()?.token;
    // Set the token in ApiService
    ApiService.setAuthToken(token);
    // Make the API call for link impressions timeline
    return ApiService.get(`${ENDPOINTS.LINK_ANALYTICS}/${linkId}/impressions-timeline?days=${days}`);
  },

  // NEW: Fetch impressions timeline for summaries
  fetchSummaryImpressionsTimeline: async (summaryId, days = 7) => {
    // Retrieve the token from StorageUtils
    const token = StorageUtils.getUserData()?.token;
    // Set the token in ApiService
    ApiService.setAuthToken(token);
    // Make the API call for summary impressions timeline
    return ApiService.get(`${ENDPOINTS.ANALYTICS}/summaries/${summaryId}/impressions-timeline?days=${days}`);
  },
 
};
